<avi-confirmation
    class="clr-wrapper"
    headerText="{{ l10nKeys.cloneDataScriptDialogHeader | vtranslate }}"
    (onClose)="handleClose()"
> 
    <avi-confirmation_modal-content>
        <form
            clrForm
            [clrLayout]="verticalLayout"
            #form="ngForm"
        >
            <avi-alert-group
                *ngIf="error"
                alertType="danger"
            >
                {{ error }}
            </avi-alert-group>
            <div class="data-script-clone-dialog__form-container">
                <avi-input-container>
                    <label
                        aviLabelWithTooltip
                        for="data-script-clone-name"
                    >
                        {{ l10nKeys.dataScriptNameLabel | vtranslate }}
                    </label>
                    <input
                        type="text"
                        clrInput
                        placeholder="{{ l10nKeys.dataScriptNameLabel | vtranslate }}"
                        [(ngModel)]="dataScriptCloneName"
                        id="data-script-clone-name"
                        name="data-script-clone-name"
                        required
                    />
                </avi-input-container>
            </div>
        </form>
    </avi-confirmation_modal-content>
    <ng-container ngProjectAs="avi-confirmation_modal-actions">
        <cds-button
            (click)="handleClose()"
            (keydown.enter)="handleClose()"
            action="outline"
        >
            {{ l10nKeys.closeButtonLabel | vtranslate }}
        </cds-button>
        <cds-button
            (click)="cloneDataScript()"
            (keydown.enter)="cloneDataScript()"
            [loadingState]="loadingState"
            [disabled]="form.invalid"
        >
            {{ l10nKeys.cloneButtonLabel | vtranslate }}
        </cds-button>
    </ng-container>
</avi-confirmation>
